import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export interface OnboardingState {
  hasSeenTour: boolean;
  hasSeenWelcomeModal: boolean;
  isTourRunning: boolean;
  isWelcomeModalOpen: boolean;
  stepIndex: number;
  setHasSeenTour: (seen: boolean) => void;
  setHasSeenWelcomeModal: (seen: boolean) => void;
  setIsTourRunning: (running: boolean) => void;
  setIsWelcomeModalOpen: (open: boolean) => void;
  setStepIndex: (index: number) => void;
  openWelcomeModal: () => void;
  dismissWelcomeModal: () => void;
  startTour: () => void;
  completeTour: () => void;
  resetTour: () => void;
}

export const useOnboardingStore = create<OnboardingState>()(
  persist(
    (set) => ({
      hasSeenTour: false,
      hasSeenWelcomeModal: false,
      isTourRunning: false,
      isWelcomeModalOpen: false,
      stepIndex: 0,
      setHasSeenTour: (hasSeenTour) => set({ hasSeenTour }),
      setHasSeenWelcomeModal: (hasSeenWelcomeModal) => set({ hasSeenWelcomeModal }),
      setIsTourRunning: (isTourRunning) => set({ isTourRunning }),
      setIsWelcomeModalOpen: (isWelcomeModalOpen) => set({ isWelcomeModalOpen }),
      setStepIndex: (stepIndex) => set({ stepIndex }),
      openWelcomeModal: () => set({ isWelcomeModalOpen: true }),
      dismissWelcomeModal: () =>
        set({ isWelcomeModalOpen: false, hasSeenWelcomeModal: true }),
      startTour: () =>
        set({
          isWelcomeModalOpen: false,
          hasSeenWelcomeModal: true,
          isTourRunning: true,
          stepIndex: 0,
        }),
      completeTour: () =>
        set({
          hasSeenTour: true,
          hasSeenWelcomeModal: true,
          isTourRunning: false,
          isWelcomeModalOpen: false,
          stepIndex: 0,
        }),
      resetTour: () =>
        set({
          hasSeenTour: false,
          hasSeenWelcomeModal: false,
          isWelcomeModalOpen: true,
          isTourRunning: false,
          stepIndex: 0,
        }),
    }),
    {
      name: 'chatagent_onboarding',
      partialize: (state) => ({
        hasSeenTour: state.hasSeenTour,
        hasSeenWelcomeModal: state.hasSeenWelcomeModal,
      }),
    }
  )
);
